import type { PeriodStatus } from './ratesChargesMock';

/** Format an ISO calendar date ("yyyy-MM-dd") as "01 Jan 2026". */
export function fmtPeriodDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

/** "From → To", or "From" with a "No expiry" tail (null `to`). */
export function periodToLabel(toIso: string | null | undefined): string {
  return toIso ? fmtPeriodDate(toIso) : 'No expiry';
}

/** Planned (starts in future) / Prior (already expired) / Current (active now). */
export function derivePeriodStatus(fromIso: string, toIso: string | null | undefined): PeriodStatus {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const from = fromIso ? new Date(fromIso) : null;
  const to = toIso ? new Date(toIso) : null;
  if (from && from > today) return 'Planned';
  if (to && to < today) return 'Prior';
  return 'Current';
}
